module.exports = __webpack_public_path__ + "static/play-store-badge-9296f1d2147f397fe206d6e3b90a8f44.svg";